import { State, initialState } from './setup.state';
import * as actions from './setup.actions';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function SetupReducer(state = initialState, action: actions.Actions): State {

  switch (action.type) {

    case actions.setupTypes.LOAD_ANTICIPATED_EXPENDITURES_SUCCESS: {
      const anticipatedExpenditures = (action as actions.LoadAnticipatedExpendituresSuccessAction).payload;

      return {
        ...state,
        anticipatedExpenditures: anticipatedExpenditures,
      };
    }

    case actions.setupTypes.SETUP_FISCAL_YEAR:
    case actions.setupTypes.SKIP_FISCAL_YEAR_SETUP: {
      return {
        ...state,
        setupSaved: 'inProgress',
      };
    }
    case actions.setupTypes.SETUP_FISCAL_YEAR_SUCCESS:
    case actions.setupTypes.SKIP_FISCAL_YEAR_SETUP_SUCCESS: {
      return {
        ...state,
        setupSaved: 'saved',
      };
    }

    case actions.setupTypes.SETUP_FISCAL_YEAR_FAILS:
    case actions.setupTypes.SKIP_FISCAL_YEAR_SETUP_FAILS: {
      return {
        ...state,
        setupSaved: 'failed',
      };
    }

  }
  return state;
}
